function checkStatus(el, status){
    switch (status) {
        case 'closed':
            el.style.backgroundColor = "#11C2A9"
            el.innerHTML = 'Finalizado'
            break;
        case 'progress':
            el.style.backgroundColor = "#FFC847"
            el.innerHTML = 'Em andamento'
            break;
        case 'new':
            el.style.backgroundColor = "#FF4A66"
            el.innerHTML = 'Novo'
            break;
        default:
            break;
    }
}


export default {
    bind: function (el, binding) {
        checkStatus(el, binding.value)
    },
    update: function( el, binding){
        checkStatus(el, binding.value)
    }
}
